import React, { useState } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Popup, UiButton } from '@shared/ui';

import cls from './Header.module.css';
import { HeaderInterface } from './HeaderInterface/HeaderInterface';
import { NestingTabs } from './NestingTabs/NestingTabs';
import { useHeader } from './useHeader';
import { CustomTooltip } from '../../../../../components/UI/CustomTooltip/CustomTooltip';
import { ChangeStartDateModal } from '../../../../../Gant/components/Modals/ChangeStartDateModal/ChangeStartDateModal';
import { AutoPlanningModal } from '../../Modals/AutoPlanningModal/AutoPlanningModal';

export const Header = () => {
    const {
        autoPlanning,
        isShowPopup,
        hidePopup,
        isShowModal,
        hideModal,
        setAutOPlanningForm,
        autOPlanningForm,
        autoPlanningMhd,
        isPlannedStages,
    } = useHeader();

    const [isOpenChangeStart, setIsOpenChangeStart] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(false);
    const { t } = useTranslation();
    const onShowChange = (value) => {
        setIsOpenChangeStart(value);
        setIsChangeStatus(false);
    };
    const onShowChangeWithStatus = (value) => {
        setIsOpenChangeStart(value);
        setIsChangeStatus(value);
    };
    return (
        <div className={classNames(cls.Header)}>
            <div className={cls.nesting}>
                <NestingTabs />
                <div data-action="change-start-date" onClick={() => onShowChangeWithStatus(true)} />
                {!isPlanFact && isPlannedStages && (
                    <CustomTooltip
                        title={t('Gant.Header.return.CustomTooltip.title')}
                        position="top"
                    >
                        <div
                            className={classNames(cls.startStage, {})}
                            onClick={() => onShowChange(true)}
                        >
                            <svg
                                width="29"
                                height="20"
                                viewBox="0 0 29 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4.76676 4.89545C5.07775 5.20085 5.07775 5.79915 4.76676 6.10455L0.962839 9.84021C0.569591 10.2264 -9.40927e-07 9.86877 -8.79428e-07 9.23565L-1.53693e-07 1.76435C-9.21896e-08 1.13119 0.569592 0.773597 0.96284 1.1598L4.76676 4.89545Z"
                                    fill="#A4A5B5"
                                />
                                <path
                                    d="M9.76676 4.89547C10.0777 5.20087 10.0777 5.79917 9.76676 6.10457L5.96285 9.84022C5.56958 10.2264 5 9.86875 5 9.23567V1.76435C5 1.13123 5.56958 0.773588 5.96285 1.15979L9.76676 4.89547Z"
                                    fill="#A4A5B5"
                                />
                                <rect x="13" width="2" height="11" rx="1" fill="#A4A5B5" />
                                <path
                                    d="M29 1H19.28C18.832 1 18.6079 1 18.4368 1.08719C18.2863 1.16389 18.1639 1.28628 18.0872 1.43681C18 1.60794 18 1.83196 18 2.28V2.72C18 3.16804 18 3.39206 18.0872 3.56319C18.1639 3.71372 18.2863 3.83611 18.4368 3.91281C18.6079 4 18.832 4 19.28 4H29V1Z"
                                    fill="#A4A5B5"
                                />
                                <path
                                    d="M29 15H25.28C24.832 15 24.6079 15 24.4368 15.0872C24.2863 15.1639 24.1639 15.2863 24.0872 15.4368C24 15.6079 24 15.832 24 16.28V16.72C24 17.168 24 17.3921 24.0872 17.5632C24.1639 17.7137 24.2863 17.8361 24.4368 17.9128C24.6079 18 24.832 18 25.28 18H29V15Z"
                                    fill="#A4A5B5"
                                />
                                <path
                                    d="M29 8H19.28C18.832 8 18.6079 8 18.4368 8.08719C18.2863 8.16389 18.1639 8.28628 18.0872 8.43681C18 8.60794 18 8.83196 18 9.28V9.72C18 10.168 18 10.3921 18.0872 10.5632C18.1639 10.7137 18.2863 10.8361 18.4368 10.9128C18.6079 11 18.832 11 19.28 11H29V8Z"
                                    fill="#A4A5B5"
                                />
                            </svg>
                        </div>
                    </CustomTooltip>
                )}
            </div>
            <Popup
                isOpen={isShowPopup}
                contentText={t('Gant.Header.return.Popup.text')}
                onHidePopup={hidePopup}
                type="alert"
            />
            <AutoPlanningModal
                isOpen={isShowModal}
                onShowChange={hideModal}
                autOPlanningForm={autOPlanningForm}
                setAutOPlanningForm={setAutOPlanningForm}
                autoPlanningMhd={autoPlanningMhd}
                isPlanFact={isPlanFact}
            />

            <ChangeStartDateModal
                isOpen={isOpenChangeStart}
                onShowChange={onShowChange}
                isChangeStatus={isChangeStatus}
            />

            <HeaderInterface />
            {isPlanFact ? (
                <div />
            ) : (
                <UiButton
                    startIcon={
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8 2.66797V13.3346V2.66797ZM8 13.3346L12 9.33463L8 13.3346ZM8 13.3346L4 9.33463L8 13.3346Z"
                                fill="#1094F7"
                            />
                            <path
                                d="M8 2.66797V13.3346M8 13.3346L12 9.33464M8 13.3346L4 9.33464"
                                stroke="#1094F7"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    }
                    className={cls.buttonClass}
                    onClick={autoPlanning}
                    data-hint-target="schedule-plan-purchases"
                    variant="text"
                    btnText={
                        <span className={classNames(cls.buttonText)}>
                            {t('Gant.Header.return.buttonText')}
                        </span>
                    }
                />
            )}
        </div>
    );
};
